module.exports = __webpack_public_path__ + "img/icon-color.eedd8733.png";